import { render, staticRenderFns } from "./VueLoading.vue?vue&type=template&id=165efad5&scoped=true"
import script from "./VueLoading.vue?vue&type=script&lang=js"
export * from "./VueLoading.vue?vue&type=script&lang=js"
import style0 from "./VueLoading.vue?vue&type=style&index=0&id=165efad5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "165efad5",
  null
  
)

export default component.exports